export const WAVESURFER_PLAYBACK_HEIGHT = 256;
/*
 * "frequencyMax" in spectrogram default was set to 12000 in Wavesurferjs v6 but 4000 in v7
 * Setting to 12000 to remain consistent with before
 */
export const SPECTROGRAM_MAX_FREQUENCY = 12000;

//  A logarithmic scale can't start at 0 Hz. Setting the minimum frequency to 20 Hz covers the lowest frequency people can hear.
export const SPECTROGRAM_MIN_FREQUENCY = 20;

// Higher values show more detail at low frequencies but less detail in time.
export const SPECTROGRAM_FFT_SAMPLES = 2048;

// The sample rate need to be twice the maximum frequency - https://wavesurfer.xyz/docs/types/plugins_spectrogram.SpectrogramPluginOptions
export const SAMPLE_RATE = SPECTROGRAM_MAX_FREQUENCY * 2;
